import { Skeleton } from '../../Skeleton'

import * as styles from './PageActions.module.css'

function PageActions({ children, className = styles.PageActions, isLoading }) {
  return (
    <div className={className}>
      {isLoading ? <Skeleton className={styles.skeleton} /> : children}
    </div>
  )
}

export default PageActions
